import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const KEY = "pn-cookie-consent";

export function CookieBanner() {
  const { lang } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch (e) { setShow(true); }
  }, []);

  const decide = (value) => {
    try { localStorage.setItem(KEY, value); } catch (e) {}
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4, ease: [0.2, 0.7, 0.2, 1] }}
          className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-3xl rounded-2xl border border-[#e4e9f0] bg-white/90 p-5 shadow-2xl backdrop-blur-md md:p-6"
        >
          <div className="flex flex-col gap-4 md:flex-row md:items-center">
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-[#FBEADD] text-[#E2611C]"><Cookie size={20} /></span>
            <p className="flex-1 text-sm leading-relaxed text-[#4a4d52]">
              {lang === "de"
                ? <>Wir verwenden ausschließlich technisch notwendige Cookies für den Betrieb dieser Website. Tracking erfolgt nur mit Ihrer Einwilligung. Mehr in unserer </>
                : <>We only use technically necessary cookies to operate this website. Tracking only with your consent. More in our </>}
              <Link to="/datenschutz" className="font-medium text-[#E2611C] underline-offset-2 hover:underline" data-testid="cookie-privacy-link">
                {lang === "de" ? "Datenschutzerklärung" : "Privacy Policy"}
              </Link>.
            </p>
            <div className="flex shrink-0 gap-2">
              <button onClick={() => decide("necessary")} data-testid="cookie-necessary"
                className="btn-ghost !px-4 !py-2 text-sm">
                {lang === "de" ? "Nur notwendige" : "Necessary only"}
              </button>
              <button onClick={() => decide("accepted")} data-testid="cookie-accept"
                className="btn-primary !px-5 !py-2 text-sm">
                {lang === "de" ? "Akzeptieren" : "Accept"}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
